import { render } from "./update_remarks.vue?vue&type=template&id=11a0cd50&scoped=true"
import script from "./update_remarks.vue?vue&type=script&lang=js"
export * from "./update_remarks.vue?vue&type=script&lang=js"

import "./update_remarks.vue?vue&type=style&index=0&id=11a0cd50&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a0cd50"]])

export default __exports__